import DialogAvatarAndDisplayName from '~/components/dialog/settings/DialogAvatarAndDisplayName.vue';
import DialogError from '~/components/dialog/error/DialogError.vue';

export const useProfileSetAvatarAndDisplayName = () => {
  const { $i18n } = useNuxtApp();

  const t = $i18n.t;

  const dialog = useDialogStore();

  const user = useUserStore();

  const profile = useProfileStore();

  const completeEvent = createEventHook<any>();

  const profileLoadFromNetwork = useProfileLoadFromNetwork();

  const forceAvatar = computed(() => profile?.featureFlags?.avatar || false);

  const forceDisplayName = computed(
    () => profile?.featureFlags?.displayName || false
  );

  const {
    openWindow: openWindowUpdateAvatar,
    onUpdated: onProfileAvatarUpdated,
  } = useProfileUpdateAvatar({
    showControls: false,
    closeClickOutside: false,
  });

  onProfileAvatarUpdated(() => {
    openWindow();
  });

  const update = async (displayName) => {
    const { error } = await useApiFetch(URI.UpdateUserProfiling, {
      method: 'POST',
      body: {
        displayName,
      },
    });
    await profileLoadFromNetwork.run();
    if (!error) return true;
    return false;
  };

  const openWindow = () => {
    dialog.lockOnSettingsLevel();
    dialog.open(DialogAvatarAndDisplayName, {
      level: DialogLevel.Settings,
      firstname: profile.displayName || user.firstname || '',
      forceAvatar: forceAvatar.value,
      forceDisplayName: forceDisplayName.value,
      onSelectEditAvatar: () => {
        openWindowUpdateAvatar();
      },
      onClose: () => {
        dialog.unlock();
      },
      onConfirm: async (value) => {
        try {
          dialog.unlock();
          const updated = await update(value);
          if (updated) {
            // dialog.unlock();
            dialog.close();
            completeEvent.trigger();
            return value;
          } else {
            dialog.open(DialogError, {
              level: DialogLevel.System,
              iconHeader: 'warning',
              label: t('error.request'),
            });
          }
        } catch (e) {
          globalThis.$logger.warn('error', e);
        }
      },
    });
  };

  const neeedAvatar = computed(
    () => forceAvatar.value && profile.displayNameAndAvatarUnset
  );

  const needDisplayName = computed(
    () => forceDisplayName.value && profile.displayNameAndAvatarUnset
  );

  const isNeeded = computed(() => {
    return neeedAvatar.value || needDisplayName.value;
  });

  return {
    isNeeded,
    openWindow,
    onComplete: completeEvent.on,
  };
};
